module.exports = __webpack_public_path__ + "static/media/dauRed.86deb900.svg";